import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { initDefalutKKActivityFactory } from '@kk-activity-factory/app-shell/initDefalutKKActivityFactory';

async function main() {
    const { store, vue } = await initDefalutKKActivityFactory();
    if (process.env.VUE_APP_HOST_ENV === 'development') {
        console.info('初始化活动工厂完成', store, vue);
    }
}

main();
